import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, format } from 'date-fns';

export function generateCalendar(year: number, month: number): string[][] {
    const firstDayOfMonth = startOfMonth(new Date(year, month - 1));
    const lastDayOfMonth = endOfMonth(firstDayOfMonth);
    const firstDayOfCalendar = startOfWeek(firstDayOfMonth, { weekStartsOn: 0 });
    const lastDayOfCalendar = endOfWeek(lastDayOfMonth, { weekStartsOn: 0 });

    let currentDate = firstDayOfCalendar;
    const weeks: string[][] = [];

    while (currentDate <= lastDayOfCalendar) {
        const week: string[] = [];
        for (let i = 0; i < 7; i++) {
            week.push(format(currentDate, 'y/M/d'));
            currentDate = addDays(currentDate, 1);
        }
        weeks.push(week);
    }
    return weeks;
}

export function isDateInRange(targetDate: string, startDate: string, endDate?: string): boolean {
    const target = new Date(targetDate).valueOf();
    const start = new Date(startDate).valueOf();
    if (!endDate) {
        return start === target;
    }
    const end = new Date(endDate).valueOf();
    return target >= start && target <= end;
}

export function countOverlappingDays(dates: string[], start: string, end: string): number {
    const toDate = (date: string) => new Date(date);
    const startDate = toDate(start);
    const endDate = toDate(end);

    return dates.filter(date => {
        const current = toDate(date);
        return current >= startDate && current <= endDate;
    }).length;
}